import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type DateRangePreset = '7d' | '14d' | '28d' | '90d' | '365d';

interface SettingsState {
  // UI preferences
  sidebarCollapsed: boolean;
  dateRange: DateRangePreset;

  // Actions
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setDateRange: (range: DateRangePreset) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      dateRange: '28d',

      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      setDateRange: (range) => set({ dateRange: range }),
    }),
    {
      name: 'chartzen-web-settings',
    }
  )
);

// Helper to convert date range preset to actual dates
export function getDateRangeFromPreset(preset: DateRangePreset): { startDate: Date; endDate: Date } {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1); // Yesterday (GSC/GA4 data has 1-2 day lag)

  const startDate = new Date(endDate);
  const days = parseInt(preset.replace('d', ''), 10);
  startDate.setDate(startDate.getDate() - days + 1);

  return { startDate, endDate };
}

// Format date for API calls
export function formatDateForAPI(date: Date): string {
  return date.toISOString().split('T')[0];
}
